// export const BASEURL = "http://localhost:3000/api/"; // local host
// export const BASEURL = "http://aswintestbk.keelis.in/api/"; // testing server
export const BASEURL = "http://aswinbk.keelis.in/api/"; // live server
